/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';
import * as _ from 'lodash';

import {ApiConfig} from '../../../components/api/api';
import {AdnShotterService} from '../../common/adn-shotter.service';
import {OBJECT_TYPE} from '../../common/constants/object-type';
import {buildLastViewedEntries} from './simple-last-viewed.util';
import template from './shotter-page.component.html';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';
import {createBufferedFlag, readBufferedFlag} from '../../common/util/template-state';
import {NavigationHistoryService} from '../../../components/util/navigation-history.service';

@Component({
  standalone: false,
  selector: 'adn-shotter-page',
  template
})
export class ShotterPageComponent implements OnInit, OnDestroy {
  lastViewed: any[] = [];
  lastViewedObject: any;
  selectFrom = 'CUSTOM';

  url = 'https://www.vg.no/nyheter/i/8q7POE/krigen-i-midtoesten-trenger-ikke-aa-vente-paa-trump';
  width = 300;
  height = 250;
  device = 'DESKTOP';
  theScript = '';
  screenshots: any[];
  screenshotting = false;
  deleting = false;
  showScreenshots: boolean;
  loaded = true;
  private readonly loadedFlag = createBufferedFlag();
  private destroyed = false;
  objectId: string;
  objectType: any;
  objectTypes = OBJECT_TYPE;
  hashResults = true;
  resp: any;
  bypassSave: boolean;
  headless: boolean;

  constructor(
    @Inject(LocalUserProfile) localUserProfile: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly adnShotter: AdnShotterService,
    private readonly uiRouter: UIRouter,
    private readonly cdr: ChangeDetectorRef,
    navigationHistory: NavigationHistoryService
  ) {
    this.lastViewed = buildLastViewedEntries(localUserProfile, this.LocalNetworkProfile);
    this.lastViewedObject = _.get(this.lastViewed, [0]);
    this.objectId = navigationHistory.previousParams.id;
    this.objectType = _.find(_.values(OBJECT_TYPE), (ot) => ot.stateName === navigationHistory.previousState?.name);
  }

  get displayLoaded(): boolean {
    return readBufferedFlag(this.loadedFlag, this.loaded, this.cdr, () => !this.destroyed);
  }

  ngOnInit(): void {
    const creativeId = this.uiRouter.globals.params.creativeId;
    if (creativeId) {
      this.objectId = creativeId;
      this.doCheck();
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  updateScript(): void {
    const theChildren = [{
      cId: this.objectId,
      w: this.width,
      h: this.height
    }];
    const env = ApiConfig.obtain().getId().replace('_adn', '');
    this.theScript = 'var scriptEl = document.createElement("script");scriptEl.src=("https://cdn.adnuntius.com/shotter.js?env=' + env + '&cjson=' + encodeURIComponent(JSON.stringify(theChildren)) + '&networkId=' + this.LocalNetworkProfile.getNetworkTag() + '");document.body.appendChild(scriptEl);';
  }

  refresh(): void {
    this.screenshotting = true;
    this.adnShotter.fetchAll().then((data: any[]) => {
      // undefined → [] flips [resolved] on adn-promise-spinner; defer to avoid NG0100.
      deferMarkForCheck(this.cdr, () => {
        this.screenshots = data;
        _.forEach(this.screenshots, (s) => {
          s.articleUrlHttps = (s.articleUrl || '').indexOf('http') === 0 ? s.articleUrl : 'https://' + s.articleUrl;
        });
      });
    }).finally(() => {
      this.screenshotting = false;
    });
  }

  deleteScreenshot(screenshot: any, index: number): void {
    this.deleting = true;
    this.adnShotter.deleteScreenshot(screenshot).then(() => {
      _.pullAt(this.screenshots, index);
    }).finally(() => {
      this.deleting = false;
    });
  }

  doCheck(): void {
    this.loaded = false;
    this.adnShotter.takeShot(this.objectId, null, this.url, this.device, this.bypassSave, this.headless).then((data: any) => {
      this.loaded = true;
      this.resp = data;
    });
  }
}
